import React from "react";

const StepBar = ({ step }) => {
  return (
    <div className="step-box">
      <div className="line-rel">
        <hr className="line-s" />
        {step === 4 ? <hr className="line-s on3" /> : null}
        {step === 3 ? <hr className="line-s on3" /> : null}
        {step === 2 ? <hr className="line-s on2" /> : null}
        {step === 1 ? <hr className="line-s on1" /> : null}
        {step === 0 ? <hr className="line-s on" /> : null}
      </div>
      {["정보입력", "동의서", "사전 서베이", "완료"].map((title, index) => (
        <div key={index} className="step-chk-box">
          <div className={index <= step ? "step-chk on" : "step-chk off"}></div>
          <p className={index <= step ? "step-text on" : "step-text off"}>
            {title}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StepBar;
